import axiosJson from "@/http/config/axiosJson";

export const candidates = (data) => axiosJson({
  loading: 'local',
  url: "/auth/login/candidates",
  method: "post",
  data
});

export const login = (data) => axiosJson({
  loading: 'local',
  url: "/auth/login",
  method: "post",
  data
});

export const sendVerificationCode = (data) => axiosJson({
  loading: 'local',
  url: "/auth/login/verification-code",
  method: "post",
  data,
  timeout: 20000,
  skipAuthRedirect: true
});

export const sendRecoveryCode = (data) => axiosJson({
  loading: 'local',
  url: '/auth/login/password-recovery/code',
  method: 'post', data, timeout: 20000, skipAuthRedirect: true
});

export const sendTemporaryPassword = (data) => axiosJson({
  loading: 'local',
  url: '/auth/login/password-recovery/temporary-password',
  method: 'post', data, timeout: 20000, skipAuthRedirect: true
});

export const session = () => axiosJson({
  loading: 'silent',
  url: "/auth/login/session",
  method: "post",
  skipAuthRedirect: true
});

export const changePassword = (data) => axiosJson({
  loading: 'local',
  url: "/auth/login/change-password",
  method: "post",
  data
});

export const logout = () => axiosJson({
  loading: 'silent',
  url: "/auth/login/logout",
  method: "post",
  timeout: 5000,
  skipAuthRedirect: true
});
